/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CompanyNoteType } from "./CompanyNoteType";
import {
  CompanyNoteTypeFromJSON,
  CompanyNoteTypeFromJSONTyped,
  CompanyNoteTypeToJSON,
  CompanyNoteTypeToJSONTyped,
} from "./CompanyNoteType";

/**
 *
 * @export
 * @interface CompanyNoteStoreLatestContact
 */
export interface CompanyNoteStoreLatestContact {
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyNoteStoreLatestContact
   */
  createdAt: OffsetDateTime;
  /**
   *
   * @type {CompanyNoteType}
   * @memberof CompanyNoteStoreLatestContact
   */
  type: CompanyNoteType;
  /**
   *
   * @type {string}
   * @memberof CompanyNoteStoreLatestContact
   */
  author: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyNoteStoreLatestContact
   */
  significant?: boolean | null;
}

/**
 * Check if a given object implements the CompanyNoteStoreLatestContact interface.
 */
export function instanceOfCompanyNoteStoreLatestContact(
  value: object,
): value is CompanyNoteStoreLatestContact {
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("author" in value) || value["author"] === undefined) return false;
  return true;
}

export function CompanyNoteStoreLatestContactFromJSON(
  json: any,
): CompanyNoteStoreLatestContact {
  return CompanyNoteStoreLatestContactFromJSONTyped(json, false);
}

export function CompanyNoteStoreLatestContactFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyNoteStoreLatestContact {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json["createdAt"],
    type: CompanyNoteTypeFromJSON(json["type"]),
    author: json["author"],
    significant: json["significant"] == null ? undefined : json["significant"],
  };
}

export function CompanyNoteStoreLatestContactToJSON(
  json: any,
): CompanyNoteStoreLatestContact {
  return CompanyNoteStoreLatestContactToJSONTyped(json, false);
}

export function CompanyNoteStoreLatestContactToJSONTyped(
  value?: CompanyNoteStoreLatestContact | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    createdAt: value["createdAt"],
    type: CompanyNoteTypeToJSON(value["type"]),
    author: value["author"],
    significant: value["significant"],
  };
}
